<div class="app" *ngIf="ready">

    <div class="main">
        <router-outlet></router-outlet>
    </div>

</div>